export const capitalizeFirstLetter = (word?: string): string => {
  if (!word) {
    return ''
  }
  return `${word.toString().charAt(0).toUpperCase()}${word.toString().slice(1)}`
}

export const usPhoneRegEx = /^\+1\s?\([0-9]{3}\)\s?[0-9]{3}-?[0-9]{4}$/

/**
 * Formats a phone number to the expected US format: +1 (XXX) XXX-XXXX
 * Handles various input formats like:
 * - "3105979727" (10 digits)
 * - "(310) 597-9727"
 * - "310-597-9727"
 * - "+1 (310) 597-9727"
 * - "+13105979727"
 */
/**
 * Extracts the database ID from a GraphQL global ID.
 * GraphQL IDs can be formatted as:
 * - "TypeName/123" (simple format)
 * - "gid://civiclift/TypeName/123" (full global ID format)
 * Returns empty string if the ID is invalid or malformed.
 */
export const extractDbIdFromGraphqlId = (graphqlId: string | null | undefined): string => {
  if (!graphqlId || typeof graphqlId !== 'string') return ''
  const parts = graphqlId.split('/')
  // Get the last segment which should be the numeric ID
  const dbId = parts.at(-1) || ''
  // Validate it looks like a numeric ID
  if (!/^\d+$/.test(dbId)) return ''
  return dbId
}

export const formatPhoneForForm = (phone: string | null | undefined): string => {
  if (!phone) return ''

  // Remove all non-digit characters
  const digits = phone.replace(/\D/g, '')

  // If it starts with 1 and has 11 digits, remove the leading 1
  const normalizedDigits = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits

  // If we don't have exactly 10 digits, return the original
  if (normalizedDigits.length !== 10) return phone

  // Format as +1 (XXX) XXX-XXXX
  const areaCode = normalizedDigits.slice(0, 3)
  const prefix = normalizedDigits.slice(3, 6)
  const lineNumber = normalizedDigits.slice(6, 10)

  return `+1 (${areaCode}) ${prefix}-${lineNumber}`
}
